import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { useField, useFormikContext } from "formik";
import { SetStateAction, useEffect, useState } from "react";
import {
  ParsedWorkflowItem,
  ReferenceData,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { MultiDropdown } from "components/dropdown/MultiDropdown";
import _ from "lodash";
import { changeWorkflowBuilderReferenceData } from "./WorkflowItem";

import editIcon from "assets/edit_icon.png";

interface Props {
  setShowTriggerTypeSelector: React.Dispatch<SetStateAction<boolean>>;
  workflowBuilderErrors: WorkflowBuilderErrors;
}

export type EditNodeProps = {
  setShowSelector: React.Dispatch<SetStateAction<any>>;
};

export const EditNode: React.FC<EditNodeProps> = ({ setShowSelector }) => {
  return (
    <div className="EditNode" onClick={() => setShowSelector(true)}>
      <img src={editIcon} alt="Edit type" className="EditNodeIcon" />
    </div>
  );
};

const SubmittedSurveyTrigger: React.FC<Props> = ({
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
}) => {
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      workflowBuilderErrors &&
      workflowBuilderErrors.trigger &&
      workflowBuilderErrors.trigger.hasOwnProperty(0)
    ) {
      const tempErrors = workflowBuilderErrors.trigger[0];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  const title = "Submitted survey";
  return (
    <div
      className={`SubmittedSurveyTrigger TriggerContainer DetailsItemContent ${
        relevantErrors && relevantErrors.length > 0 ? "Error" : ""
      }`}
    >
      <label className="Title">
        <div className="Text">{`Trigger - ${title}`}</div>

        <EditNode setShowSelector={setShowTriggerTypeSelector} />
      </label>

      {relevantErrors && relevantErrors.length > 0 && (
        <div className="Errors">
          {relevantErrors.map(error => {
            return <div className="Error">{error}</div>;
          })}
        </div>
      )}
    </div>
  );
};

export default SubmittedSurveyTrigger;
